<ul class="nav nav-main-block">
    <ng-container *ngFor="let leftMenu of leftNavigation; index as lastMenu">
        <!-- Icon block -->
        <li
            *ngIf="leftMenu.permission"
            class="nav-sub-list">
            <ul class="nav nav-sub dk nav-first-tab">
                <ng-container *ngFor="let subMenu of leftMenu.items">
                    <!-- First Menu  -->
                    <li
                        *ngIf="subMenu.permission"
                        class="nav-sub-sub-list nav-first-onhover"
                        (click)="subMenu.route ? goToUrl(subMenu.route!) : ''">
                        <span>{{ subMenu.name | translate }}</span>
                        <ul
                            class="nav nav-sub dk nav-second-tab"
                            [class.nav-overflow-tab]="lastMenu === 3">
                            <ng-container *ngFor="let subsubMenu of subMenu.items">
                                <!-- Second Menu -->
                                <a
                                    *ngIf="subsubMenu.permission"
                                    (click)="goToUrl(subsubMenu.route!, subsubMenu.identifier)">
                                    <li class="nav-second-onhover">
                                        <span>{{ subsubMenu.name | translate }}</span>
                                    </li>
                                </a>
                            </ng-container>
                        </ul>
                    </li>
                </ng-container>
            </ul>
            <a><i class="{{ leftMenu.icon }}"></i></a>
        </li>
    </ng-container>
</ul>

<!-- Each ng container represents a block from the obj -->
